import React from 'react';
import {useFormik} from 'formik';
import './ChangePassword.scss';
import ResponsiveAppBar from '../../components/shared/Menubar/ResponsiveAppBar';
import {AppRoutes} from "../../Router";
import {ArrowBack} from '@mui/icons-material';
import Fab from '@mui/material/Fab';
import {useNavigate} from 'react-router-dom';
import {useLoginContext} from '../../hooks/useLoginContext';
import {AuthService} from '../../services';
import toast from 'react-hot-toast';
import {WloCreditoService} from '../../types';

const changePasswordCopy = {
    back: "Atr\u00e1s",
    title: "Cambio de contrase\u00f1a",
    description: "La nueva contrase\u00f1a debe tener al menos una may\u00fascula, una min\u00fascula, un n\u00famero, un car\u00e1cter especial y un m\u00ednimo de 8 caracteres.",
    currentPassword: "Contrase\u00f1a actual",
    newPassword: "Contrase\u00f1a nueva",
    confirmPassword: "Confirmar contrase\u00f1a",
    submit: "Restablecer",
    currentPasswordError: "contrase\u00f1a actual no es correcta",
    mismatchError: "Nueva contrase\u00f1as no se iguales",
};

export const ChangePassword = () => {
    const navigate = useNavigate();
    const {user} = useLoginContext();

    const getTargetUser = () => {
        const raw = sessionStorage.getItem('cambioAdm');
        if (!raw) {
            return null;
        }
        try {
            return JSON.parse(raw);
        } catch {
            return null;
        }
    };

    const handleBack = () => {
        if (sessionStorage.getItem('cambioAdm')) {
            sessionStorage.removeItem('cambioAdm');
            navigate(AppRoutes.USUARIOS_PLATAFORM, {replace: true});
        } else {
            navigate(AppRoutes.MENU_USER, {replace: true});
        }
    };

    const formik = useFormik({
        initialValues: {
            current: '',
            new: '',
            confirm: ''
        },
        onSubmit: async values => {
            const datosUser = getTargetUser();
            const identificacion = datosUser?.iden || user.idUser!;
            const tipoIdentificacion = datosUser?.tipoIden || user.typeUse!;
            const tipoPerfil = datosUser?.tipoPer || user.idProfile!;

            const userLogin: WloCreditoService.LoginRequest = {
                Pws_Identificacion: identificacion,
                Pws_Tip_identificacion: tipoIdentificacion,
                Pws_clave_usu: values.current,
                Pws_Tip_perfil: tipoPerfil,
                Pws_Tip_Canal: "1",
                Pws_Tip_cambio: "1",
            }
            const result = await AuthService.login(userLogin);
            if (result.payload.Ws_LoginResult.Resultado <= 0) {
                toast.error(changePasswordCopy.currentPasswordError, {
                    duration: 5000,
                })
            } else {
                if (values.new === values.confirm) {
                    const valorChagePass = await AuthService.changepassword({
                        Pws_Tip_cambio: "2",
                        Pws_Identificacion: identificacion,
                        Pws_Tip_identificacion: tipoIdentificacion,
                        Pws_Tip_perfil: tipoPerfil,
                        Pws_clave_enc1: values.new,
                        Pws_clave_enc2: values.new,
                        Pws_Base_datos: "2"
                    })
                    if (Number(valorChagePass.payload.result) > 0) {
                        toast.success(valorChagePass.payload.message, {
                            duration: 5000,
                        })
                        if (sessionStorage.getItem('cambioAdm')) {
                            sessionStorage.removeItem('cambioAdm');
                            navigate(AppRoutes.USUARIOS_PLATAFORM, {replace: true});
                        } else {
                            navigate(-1);
                        }
                    } else {
                        toast.error(valorChagePass.payload.message, {
                            duration: 5000,
                        })
                    }
                } else {
                    toast.error(changePasswordCopy.mismatchError, {
                        duration: 5000,
                    })
                }
            }
        },
    });

    return (
        <>
            <ResponsiveAppBar/>
            <main className="change-pass">
                <div className="change-pass-toolbar">
                    <Fab
                        variant="extended"
                        color="neutral"
                        aria-label={changePasswordCopy.back}
                        onClick={handleBack}
                        className="change-pass-back-button hooverButtonRed"
                    >
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {changePasswordCopy.back}
                    </Fab>
                </div>

                <section className="change-pass-panel" aria-labelledby="change-pass-title">
                    <div className="change-pass-header">
                        <h1 id="change-pass-title">{changePasswordCopy.title}</h1>
                        <p>{changePasswordCopy.description}</p>
                    </div>

                    <form onSubmit={formik.handleSubmit} className="change-pass-form">
                        <div className="change-pass-field">
                            <label htmlFor="current">{changePasswordCopy.currentPassword}</label>
                            <input
                                id="current"
                                name="current"
                                type="password"
                                onChange={formik.handleChange}
                                value={formik.values.current}
                                placeholder="Ingresar"
                                autoComplete="current-password"
                            />
                        </div>
                        <div className="change-pass-field">
                            <label htmlFor="new">{changePasswordCopy.newPassword}</label>
                            <input
                                id="new"
                                name="new"
                                type="password"
                                onChange={formik.handleChange}
                                value={formik.values.new}
                                placeholder="Ingresar"
                                autoComplete="new-password"
                            />
                        </div>
                        <div className="change-pass-field">
                            <label htmlFor="confirm">{changePasswordCopy.confirmPassword}</label>
                            <input
                                id="confirm"
                                name="confirm"
                                type="password"
                                onChange={formik.handleChange}
                                value={formik.values.confirm}
                                placeholder="Ingresar"
                                autoComplete="new-password"
                            />
                        </div>
                        <div className="password-change">
                            <button type="submit">{changePasswordCopy.submit}</button>
                        </div>
                    </form>
                </section>
            </main>
        </>
    );
};
